export enum ExperienceType {
  Positive = 'Positive',
  Neutral = 'Neutral',
  Negative = 'Negative',
}
